<template>
   <q-dialog v-model="dialog">
       <div class="hris-modal" style="max-width: 480px;">
         <div class="hris-modal-header">
           <h2 class="hris-modal-title">{{ title }}</h2>
         </div>
         <div class="hris-modal-body">
            <q-list bordered separator class="hris-panel" style="padding: 0; margin-bottom: 0; overflow: hidden; box-shadow: none;">
             <q-item v-for="reason in otherReason" :key="reason">
               <q-item-section>{{ reason }}</q-item-section>
             </q-item>
           </q-list>
         </div>
         <div class="hris-modal-footer">
           <q-btn unelevated class="hris-q-primary" label="OK" v-close-popup></q-btn>
         </div>
       </div>
     </q-dialog>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';

export default {

   data() {
     return {
        dialog:false,
        title:"",
        otherReason:{}
     }
   },

  created(){
    this.eventHub.$on('showOtherAnswer', this.showOtherAnswer);
  },

  methods: {
   showOtherAnswer:function(payload){
      this.title = payload.title
      this.otherReason = payload.reasons
      this.dialog = true;
   },

}
}
</script>
<style lang="css" scoped>
</style>
